
import Vue from 'vue'
import MainLayout from '@/components/MainLayout.vue'
import userManager from '@/user-manager'
import i18n from '@/plugins/i18n'
import { translateUser } from '@/utils/translator'
import { UserDto } from '@chainsight/networker-backend-axios-sdk'

export default Vue.extend({
	name: 'NonLoginSharingProfile',
	components: {
		MainLayout
	},
	data() {
		return {
			overlay: false,
			userDto: {} as UserDto,
		}
	},
	computed: {
		blobBaseUrl() {
			return process.env.VUE_APP_BLOB_API_BASE_URL
		}
	},
	methods: {
		normalizedWebsite(url: string): string {
			if (!url) return ''
			if (url.startsWith('http://') || url.startsWith('https://')) {
				return url
			}
			return 'https://' + url
		},
		async getSharingUser() {
			this.overlay = true
			try {
				const sharingProfileId = this.$route.params.sharingProfileId
				const response = await this.api$.sharingUserApi.getSharingUser(sharingProfileId)
				if (response.data.data?.user) {
					this.userDto = response.data.data.user as UserDto

					// 即時翻譯
					if (i18n.locale === 'zh') {
						await translateUser(this.userDto, 'zh-Hant')
					} else if (i18n.locale === 'en') {
						await translateUser(this.userDto, 'en-US')
					} else if (i18n.locale === 'ja') {
						await translateUser(this.userDto, 'ja-JP')
					}
				}
			} catch (error) {
				console.error('Error fetching sharing user:', error)
			}
			this.overlay = false
		},
		login() {
			localStorage.setItem('LOGIN_TO_PAGE', 'chat')
			localStorage.setItem('SHARING_PROFILE_ID', this.$route.params.sharingProfileId)
			localStorage.setItem('TARGET_USER_ID', this.userDto?.id as string)
			userManager.signinRedirect()
		}
	},
	async created() {
		await this.getSharingUser()
	},
	watch: {
		'$i18n.locale': {
			immediate: false,
			async handler() {
				if (!this.userDto?.id) return
				this.overlay = true
				try {
					// 重新取得原始資料並翻譯
					const sharingProfileId = this.$route.params.sharingProfileId
					const response = await this.api$.sharingUserApi.getSharingUser(sharingProfileId)
					if (response.data.data?.user) {
						this.userDto = response.data.data.user as UserDto

						if (i18n.locale === 'zh') {
							await translateUser(this.userDto, 'zh-Hant')
						} else if (i18n.locale === 'en') {
							await translateUser(this.userDto, 'en-US')
						} else if (i18n.locale === 'ja') {
							await translateUser(this.userDto, 'ja-JP')
						}
					}
				} catch (error) {
					console.error('Error re-translating user:', error)
				}
				this.overlay = false
			}
		}
	}
})
